<div class="autocomplete-holder">
  <ng-template [ngTemplateOutlet]="defaultHeaderTemplate" [ngTemplateOutletContext]="{ label: label, hint: hint }">
  </ng-template>
  <div class="dropdown" clickOutside (clickOutside)="handleClickOutside()">
    <rx-please-wait-circle *ngIf="showLoading"> </rx-please-wait-circle>
    <rx-input
      #autocompleteInput
      type="text"
      autocomplete="off"
      [formControl]="query"
      [value]="query.value"
      [compact]="compact"
      [placeholder]="placeholder"
      [error]="$any(error)"
      [leftIcon]="leftIcon"
      [cleanFieldIcon]="cleanFieldIcon"
      (click)="onClick()"
      (toggle)="onFocus()"
      (mouseenter)="onMouseHover()"
      (mouseleave)="onMouseLeave()"
    >
    </rx-input>
    <ng-container
      [ngTemplateOutlet]="query.value && query.value.length ? defaultContainerTemplate : clickOptionsTemplate"
      [ngTemplateOutletContext]="{
        $implicit: query.value && query.value.length ? options : clickOptions,
        title: query.value && query.value.length ? null : clickOptionsHeader,
        bindValue: bindValue,
        bindLabel: bindLabel,
        bindAppend: bindAppend,
      }"
    >
    </ng-container>
  </div>
  <ng-content select="[rx-error]"></ng-content>
</div>

<ng-template #defaultHeaderTemplate>
  <label [for]="" *ngIf="label">
    <span>{{ label }}</span>
    <small *ngIf="hint">{{ hint }}</small>
    <span *ngIf="secondaryLabel"> - </span>
    <small class="secondary-label">{{ secondaryLabel }}</small>
  </label>
</ng-template>

<ng-template #defaultContainerTemplate let-options>
  <ng-container *ngIf="options && (options.length || footerTemplate) && focused">
    <ul class="dropdown-menu" @collapseExpand>
      <li
        rxIsEllipsisActive
        class="dropdown-item"
        *ngFor="let item of options | slice: 0 : 10; let i = index"
        [ngClass]="{
          'dropdown-hover': i === rowLocation,
        }"
        [attr.data-qa]="'autocomplete-result-' + i"
        (click)="selectItem(item)"
        (mouseover)="rowLocation = i"
      >
        <ng-template
          [ngTemplateOutlet]="templateRef"
          [ngTemplateOutletContext]="{ $implicit: item }"
          *ngIf="templateRef; else templateDefault"
        ></ng-template>
        <ng-template #templateDefault>
          <span
            class="label-text"
            [innerHTML]="(bindLabel ? $any(item[bindLabel]) : item) | myHighlight: query.value"
          ></span>
          <span class="label-append">{{ bindAppend ? $any(item[bindAppend]) : null }}</span>
        </ng-template>
      </li>
      <li class="rx-autocomplete-footer">
        <ng-template [ngTemplateOutlet]="footerTemplate"> </ng-template>
      </li>
    </ul>
  </ng-container>
</ng-template>

<ng-template #clickOptionsTemplate let-groups>
  <ng-container *ngIf="focused && (groups.length || footerTemplate)">
    <ul class="dropdown-menu" @collapseExpand>
      <ng-container *ngFor="let group of groups">
        <li class="dropdown-header" *ngIf="group.heading">
          {{ group.heading }}
        </li>
        <li rxIsEllipsisActive class="dropdown-item" *ngFor="let item of group.options" (click)="selectItem(item)">
          <span class="label-text" [innerHTML]="bindLabel ? item[bindLabel] : item"></span>
          <span class="label-append">{{ bindAppend ? item[bindAppend] : null }}</span>
        </li>
      </ng-container>
      <li class="rx-autocomplete-footer">
        <ng-template [ngTemplateOutlet]="footerTemplate"> </ng-template>
      </li>
    </ul>
  </ng-container>
</ng-template>
